import {
  List,
  AssignmentTurnedIn,
  CheckCircle,
  Schedule,
  HourglassEmpty,
  SupportAgent,
  Person,
} from '@mui/icons-material';
import { permit } from '@lba-dev/package.local-globals/restrictions';

import { getUserTeam } from '../../../utils/teams';

const baseUrl = '/preSavIntervention/list/';
const baseParams = 'login-ajout';

const canViewCommercial = (user) =>
  permit(user) || permit(user, { key: 'savAssign' });

const mesSections = [
  {
    name: 'Tout',
    icon: List,
    count: true,
    link: (e) => `${baseUrl}mesPreSav/${baseParams}=${e.login}=${e._id}`,
  },
  {
    name: 'À Programmer',
    icon: Schedule,
    count: true,
    link: (e) =>
      `${baseUrl}mesPreSavAPR/${baseParams}=${e.login}=${e._id}`,
  },
  {
    name: 'En cours',
    icon: HourglassEmpty,
    count: true,
    link: (e) =>
      `${baseUrl}mesPreSavENC/${baseParams}=${e.login}=${e._id}`,
  },
  {
    name: 'À Vérifier',
    icon: AssignmentTurnedIn,
    count: true,
    link: (e) =>
      `${baseUrl}mesPreSavAVR/${baseParams}=${e.login}=${e._id}`,
  },
  {
    name: 'Réalisé',
    icon: CheckCircle,
    count: true,
    link: (e) =>
      `${baseUrl}mesPreSavREAL/${baseParams}=${e.login}=${e._id}`,
  },
];

export default ({ user, users }) => {
  const team = getUserTeam(users || [], user._id);
  const isChief = permit(user, { key: 'savAssign' });

  return [
    ...(canViewCommercial(user) ? [
      {
        name: 'Pré-SAV Commercial',
        icon: AssignmentTurnedIn,
        childs: [
          {
            name: 'Tout',
            icon: List,
            link: () => '/preSavIntervention/list/preSavTout',
            count: true,
          },
          {
            name: 'En cours',
            icon: HourglassEmpty,
            link: () => '/preSavIntervention/list/preSavEnCours',
            count: true,
          },
          {
            name: 'Réalisés',
            icon: CheckCircle,
            link: () => '/preSavIntervention/list/preSavRealises',
            count: true,
          },
        ],
      },
    ] : []),
    ...(isChief && team ? [
      {
        name: 'Mon équipe',
        icon: Schedule,
        childs: [
          {
            name: 'Tout',
            icon: List,
            count: true,
            link: () => `${baseUrl}preSavEquipeTout_${team._id}`,
          },
          {
            name: 'À Programmer',
            icon: Schedule,
            count: true,
            link: () => `${baseUrl}preSavEquipeAPR_${team._id}`,
          },
          {
            name: 'En cours',
            icon: HourglassEmpty,
            count: true,
            link: () => `${baseUrl}preSavEquipeENC_${team._id}`,
          },
          {
            name: 'À Vérifier',
            icon: AssignmentTurnedIn,
            count: true,
            link: () => `${baseUrl}preSavEquipeAVR_${team._id}`,
          },
          {
            name: 'Réalisé',
            icon: CheckCircle,
            count: true,
            link: () => `${baseUrl}preSavEquipeREAL_${team._id}`,
          },
        ],
      },
    ] : []),
    {
      name: 'Mes Pré-SAV',
      icon: Person,
      childs: mesSections,
    },
    {
      name: 'Support Pré-SAV',
      icon: SupportAgent,
      link: () => '/preSavIntervention/list/preSavSupport',
      count: true,
    }
  ];
};
